import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./Component/Home";
import About from "./Component/About";
import Contact from "./Component/Contact";
import Services from "./Component/Services";
import ErrorPage from "./Component/ErrorPage";
import List from "./Component/List";
import Footer from "./Component/Footer";
import Pricing from "./Component/Pricing";
import Login from "./Component/Login";
import Signup from "./Component/Signup";
import Dashboard from "./Component/Dashboard";
import CheckoutSuccess from "./Component/CheckoutSuccess";
import ProtectedRoute from "./Component/ProtectedRoute";
import PublicOnlyRoute from "./Component/PublicOnlyRoute";

const App = () => {
  const location = useLocation();
  const hideChrome = ["/login", "/signup"].includes(location.pathname);

  return (
    <>
      {!hideChrome && <List />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route
          path="/login"
          element={<PublicOnlyRoute><Login /></PublicOnlyRoute>}
        />
        <Route
          path="/signup"
          element={<PublicOnlyRoute><Signup /></PublicOnlyRoute>}
        />
        <Route
          path="/dashboard"
          element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
        />
        <Route
          path="/checkout/success"
          element={<ProtectedRoute><CheckoutSuccess /></ProtectedRoute>}
        />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
      {!hideChrome && <Footer />}
    </>
  );
};
export default App;
